/* eslint-disable */
/*
Notes: we should combine code from CreatePostSaga and EditPostScreen into PostSagas.js.
Right now we have three sets of code, each screen choosing which to use.
*/

import { call, put, fork, take, select } from 'redux-saga/effects'
import { path } from 'ramda'
import PostsActions from '../Redux/PostsRedux'
import { showError } from '../Lib/utils'
import { AWSConfig } from '../Config/AppConfig'
//import RNFetchBlob from 'react-native-fetch-blob'
import { MEDIA_TYPES } from '../Constant'
import CreatePostActions from "../Redux/CreatePostRedux"
import { AsyncStorage } from '@react-native-async-storage/async-storage'

//AWS3
import AWS from 'aws-sdk/dist/aws-sdk-react-native'
import { NavigationActions } from 'react-navigation';
//import Upload from 'react-native-background-upload'
//import RNFS from 'react-native-fs'
import {Alert} from 'react-native'
import I18n from "i18n-js"
import { setBadgeCount } from 'react-native-notification-badge'
//import EventEmitter from 'EventEmitter'
import {TinyEmitter} from 'tiny-emitter'
import API from '../Services/Api'

// for logging only
const logapi = API.create( )

var creds = new AWS.Credentials(AWSConfig.AWSKey, AWSConfig.AWSSecret);
const S3 = new AWS.S3({
  region: AWSConfig.region,
  credentials: creds
});

export function* reportPost(api, action) {
  try {
    const { data } = action
    const response = yield call(api.reportPost, data)
    if (response.ok) yield put(PostsActions.reportPostSuccess(response))
    else yield put(PostsActions.reportPostFailure())
  } catch (e) { showError(e) }
}
export function* getPosts(api, action) {
  try {
    const { post } = action
    let t1 = Date.now()
    const response = yield call(api.getPosts, post)
    let t2 = Date.now()
    console.log("TIMING getPosts = " + (t2-t1))
    if (response.ok) {

      yield put(PostsActions.postsSuccess(response))
    } else {
      yield put(PostsActions.postsFailure())
    }
  } catch (e) {
    showError(e)
  }
}

export function* repost(api, action) {
  try {
    // console.tron.log(`PostsSagas repost replaceWithAnimation home`)
    // const resetAction = NavigationActions.replaceWithAnimation({ route Name: 'home', params: {isScroll : true, isNewPost : true} })
    // yield put(resetAction)
    const { post } = action
    const response = yield call(api.repost, post)
    if (response.ok) {
      yield put(PostsActions.repostSuccess(response))
    } else {
      yield put(PostsActions.repostFailure())
    }
  } catch (e) {
    console.tron.display({
      name: `repost error`,
      preview: ``,
      value: {
        state: e,

      }
    })

    showError(e)
  }
}
export function* updatePost(api, action) {
  try {
    const { post } = action
    console.tron.display({
      name: `updatePost saga`,
      preview: ``,
      value: {
        state: post
      }
    })


    const response = yield call(api.updatePost, post)
    if (response.ok) {
      // Handle navigation behaviour within EditPostScreen componentDidUpdate
      // const resetAction = NavigationActions.replaceWithAnimation({
      //  routeName: 'profile', params: { postId: post.PostId, userId: post.UserId } })
      // yield put(resetAction)
      yield put(PostsActions.updatePostSuccess(response))
    } else {
      yield put(PostsActions.updatePostFailure())
      console.warn('post update error!')
      console.warn(response)
    }
  } catch (e) {
    showError(e)
  }
}
export function* readPost(api, action) {
  const { post: { PostId } } = action
  let t1 = Date.now()
  const response = yield call(api.readPost, { PostId: PostId })
  let t2 = Date.now()
   console.log("TIMING readPost = " + (t2-t1))
  if (response.ok) {
    yield put(PostsActions.readPostSuccess(response))
  } else {
    yield put(PostsActions.readPostFailure())
  }
}
export function* readMultiPost(api, action) {
  const { data } = action
  let t1 = Date.now()
  const response = yield call(api.getPostsDetail, { data: data })
  let t2 = Date.now()
   console.log("TIMING readMultiPost = " + (t2-t1))
  if (response.ok) {
    yield put(PostsActions.readMultiPostSuccess(response))
  } else {
    yield put(PostsActions.readMultiPostFailure())
  }
}
export function* deleteHashTag(api, action) {
  try {
    const { data } = action
    const response = yield call(api.deleteHashTag, data)
    if (response.ok) yield put(PostsActions.deleteHashTagSuccess(response))
    else yield put(PostsActions.deleteHashTagFailure())
  } catch (e) {
    console.warn('deleteHashTag failure: ', JSON.stringify(e))
    yield put(PostsActions.deleteHashTagFailure())
  }
}

export function* getPostsItem(api, action) {
  try {
    const { post } = action
    var chunksize = 10;
    var chunks = [];
    console.tron.display({
      name: `post`,
      preview: ``,
      value: {
        state: post
      }
    })

    post.Posts.forEach((item) => {
      if (!chunks.length || chunks[chunks.length - 1].length == chunksize)
        chunks.push([]);
      chunks[chunks.length - 1].push(item.PostId);

    });


    var dataRequest = {
      PostId: "",
      PostIds: ""
    };
    for (element of chunks) {

      dataRequest.PostId = element[0]
      dataRequest.PostIds = element.toString()
      console.tron.display({
        name: `dataRequest`,
        preview: ``,
        value: {
          state: dataRequest
        }
      })

      // yield fork(getPostsItemAsyn,api, { PostId: element.PostId })
      const response = yield call(api.getPostsDetail,
        dataRequest)


      if (response.ok) {


        yield put(PostsActions.postsItemSuccess(response))
      } else {
        yield put(PostsActions.postsItemFailure())
      }
    }



  } catch (e) {
    console.tron.display({
      name: `getPostsItem faile`,
      preview: ``,
      value: {
        state: e
      }
    })

  }
}
export function* getLikePost(api, action) {
  try {
    const response = yield call(api.getLikePost)
    if (response.ok) yield put(PostsActions.postsLikeSuccess(response))
    else yield put(PostsActions.postsLikeFailure())
  } catch (e) { console.warn('getLikePost failure: ', JSON.stringify(e)) }
}
export function* searchTagPost(api, { post }) {
  try {
    //const { post } = action
    const response = yield call(api.searchTagPost, post)
    if (response.ok) yield put(PostsActions.postsTagSuccess(response))
    else yield put(PostsActions.postsTagFailure())
  } catch (e) { console.warn('searchTagPost failure: ', JSON.stringify(e)) }
}
export function* postTagDetail(api, { post }) {
  try {
    //const { post } = action
    const response = yield call(api.getPostTagDetail, post)
    if (!response) console.log("caution, null response from getPostTagDetail")
    if (response.ok) {
      yield put(PostsActions.postTagDetailSuccess(response))
    } else {
      yield put(PostsActions.postTagDetailFailure())
    }
  } catch (e) { console.warn('postTagDetail failure: ', JSON.stringify(e)) }
}


//all likes
export function* getPostAllLikes(api, action) {
  try {
    const { postId } = action
    const response = yield call(api.getPostAllLikes, postId)
    if (response.ok) {
      yield put(PostsActions.getPostAllLikesSuccess(response))
    } else {
      yield put(PostsActions.getPostAllLikesFailure())
    }
  } catch (e) {
    showError(e)
  }
}

//comments
export function* getPostComments(api, action) {
  try {
    const { params: { postId, start, limit } } = action
    const response = yield call(api.getPostComments, postId, start, limit)
    if (response.ok) {
      yield put(PostsActions.getPostCommentsSuccess(response))
    } else {
      yield put(PostsActions.getPostCommentsFailure())
    }
  } catch (e) {
    showError(e)
  }
}

export function* postComment(api, action) {
  try {
    const { params: { postId, body } } = action

    const response = yield call(api.postComment, postId, body)
    if (response.ok) {
      yield put(PostsActions.postCommentSuccess(response))
    } else {
      yield put(PostsActions.postCommentFailure())
    }
  } catch (e) {
    yield put(PostsActions.postCommentFailure())
    showError(e)
  }
}

export function* deleteComment(api, action) {
  try {
    const { params: { postId, timestamp } } = action

    const response = yield call(api.deleteComment, postId, timestamp)

    if (response.ok) {
      yield put(PostsActions.deleteCommentSuccess(timestamp))
    } else {
      yield put(PostsActions.deleteCommentFailure())
    }
  } catch (e) {
    yield put(PostsActions.deleteCommentFailure())
    showError(e)
  }
}

//search  user mentioned
export function* searchUser(api, action) {
  try {
    const { params: { text, limit } } = action
    const response = yield call(api.searchUser,{user : text , limit})
    if (response.ok) {
      yield put(PostsActions.searchUserSuccess(response))
    } else {
      yield put(PostsActions.searchUserFailure())
    }
  } catch (e) {
    showError(e)
  }
}

const delay = (ms) => new Promise(res => setTimeout(res, ms))

// only 1st arg used for non background upload, adding extra args for compat w/ background version (native code)
const s3Upload = (details, progressCallback, postId, userId, username) => {

  let dkeys = Object.keys(details)

  for (let i = 0; i < dkeys.length; i++) {
    if (typeof details[dkeys[i]] == 'string')
      console.info("detail key " + dkeys[i] + " " + details[dkeys[i]].substring(0,60))
    else 
      console.info("detail key " + dkeys[i] + " " + details[dkeys[i]])
  }

  if (false) { // debug only
    console.log("s3Upload details keys = " + Object.keys(details))
    let keys = Object.keys(details)
    for (let i = 0; i < keys.length; i++) {
      if (typeof details[keys[i]] == 'string')
        console.log("key " + keys[i] + " = " + details[keys[i]].substr(0, 60))
      else
        console.log("key " + keys[i] + " = " + details[keys[i]])
    }
  }
  console.tron.display({
    name: 's3Upload',
    preview: 'details',
    value: {
      presignedUrl: details.presignedUrl,
      // details: details
    }
  })

  // if we dont have a base64 string directly and we do have a data uri, get the base64 string from the data uri
  // this may be be foolproof e.g. data types, use pattern replace later?
  // what if some other image type (newer fancy apple type)
  if (!details.base64 && details.uri && (typeof details.uri == 'string') && details.uri.substring(0,5) == 'data:') {
    details.base64 = details.uri.replace('data:image/png;base64,', '').replace('data:image/jpeg;base64,', '')
  }

  console.info("typeof details.uri = " + (typeof details.uri))

  // all images will have a base64 here
  if (details.base64 || details.kind == 'video') {

    if (false) // native
      return RNFetchBlob.fetch('PUT', details.presignedUrl, headers, details.base64)
        .uploadProgress({ interval: details.interval }, (written, total) => {
        }) 
    else {
      
      // this block needs to return a promise like RNFetchBlob.fetch
        
      // send data url with prefix (?) but maybe our stuff is different hmm
      // https://medium.com/@cherifmezdarii/image-upload-base64-to-server-react-native-18488988bf49

      // our data from kargoe web, note that base64 is unprefixed

      // key base64 = /9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsL 
      // key uri = data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAgGB 

      console.info('ready for xhr PUT')
      
      console.info("presignedUrl = " + details.presignedUrl)

      function dataURItoBlobNEW(dataURIWithoutPrefix) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        //var byteString = atob(dataURI.split(',')[1]);

        var byteString = atob(dataURIWithoutPrefix)
    
        // separate out the mime component
        var mimeString = 'image/jpeg' // dataURI.split(',')[0].split(':')[1].split(';')[0];
    
        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
    
        return new Blob([ab], {type: mimeString});
      }

      //console.log("ready to call fetch for " + details.presignedUrl)

      let theBlob = (details.kind != 'video') ? dataURItoBlobNEW(details.base64) : null // ah. this works for image upload.

      // this would be ideal but can't use await here, so do the promisey stuff below in xhr.send()
      
      /*
      if (details.kind == 'video') // video is in a blob uri
        fetch(details.uri).then(r => r.blob()).then(blob => {
            console.log('got video blob = ' + blob)
            console.log('video blob size = ' + blob.size)
            console.log('video blob type = ' + blob.type) 
        }) // can we use await here?  no.  have to be in some sort of mumble async function
      */

      console.info("blob is " + theBlob)

      if (theBlob) {
        console.info("blob size " + theBlob.size) // small size like 3 is warning sign
        console.info("blob type " + theBlob.type) // this is showing image
      }

      let outsideResolveWeb = null
      let outsideRejectWeb = null

      // Set up our HTTP request
      let xhr = new XMLHttpRequest();

      xhr.addEventListener("error", (x) => {
        console.info("xhr upload image error PostsSagsas x = " + x)
      }, false)

      // Setup our listener to process completed requests
      xhr.onreadystatechange = function () {
	      if (xhr.readyState !== 4) return; // all other states = incomplete

        let responseHeaders = xhr.getAllResponseHeaders()

        console.info('xhr responseHeaders = ' + responseHeaders) // this is a string may need work

        console.info('xhr status = ' + xhr.status)

        // the caller needs results from response headers, this response seems to be empty
	      if (xhr.status >= 200 && xhr.status < 300) {
		      console.info("response text = " + xhr.responseText)
	      }
        else console.info("error from xhr uploader, status = " + xhr.status)

        // match up to what calling code wants to see
        let responseOut = {
          respInfo : {
            status  : xhr.status,
            headers : responseHeaders // maybe need to parse this, I am only sending text here
          }
        }

        if (outsideResolveWeb) {
         console.info('ready to resolve webpromise')
         outsideResolveWeb(responseOut) // this resolves webpromise, see below
        }

      }

      xhr.open('PUT', details.presignedUrl, true) // last arg async
      //xhr.setRequestHeader('Access-Control-Allow-Origin', '*')
      xhr.setRequestHeader('Access-Control-Expose-Headers', '*')
      xhr.setRequestHeader('Content-Type', 'application/octet-stream')
      xhr.setRequestHeader('Accept', '*/*')
      xhr.setRequestHeader('User-Agent' , 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10.14; rv:89.0) Gecko/20100101 Firefox/89.0')

      if (details.kind != 'video') {
        console.info('sending image blob via xhr')
        if (theBlob && theBlob.size > 10) {// 3 was cutoff but ... 
          console.info("sending theBlob with xhr now")
          xhr.send(theBlob) // image send
        }
        else
          console.info("skipping blob send, it is too small")
      }
      else {
        // so many many promises...
        // 
        console.info('ready to get video blob from details.uri, the start of which is = ' + details.uri.substring(0,60))
        // for some reason this is not working
        if (true)
        fetch(details.uri).then(r => 
          {
            console.info("first bit of fetch for video blob ok, try to do second bit")
            r.blob().then(videoBlob => {
              console.info('got video blob = ' + videoBlob + ' sending via xhr')
              xhr.send(videoBlob)
            })
          }
        ).catch(x => {
          console.info("error " + x + " getting video blob")
        })
      }

      // make sure we return a promise that does the same thing as RNFetchBlob 

      // see:  https://stackoverflow.com/questions/26150232/resolve-javascript-promise-outside-function-scope
      // and elsewhere in this file the same pattern, this is way to do like an impedence match between
      // mismatching promises 

      const webpromise = new Promise(function(resolve, reject) {
        // see define of these above in let
        outsideResolveWeb = resolve
        outsideRejectWeb = reject
      })

      return webpromise
    }
  }
  else {
    // no file urls allowed on web 
    var path = details.uri.replace(/^file:../,'')
    console.log("trying to upload from file or data url, len = " + path.length)
    if (false)
      return RNFetchBlob.fetch('PUT', details.presignedUrl, headers, RNFetchBlob.wrap(path))
        .uploadProgress({ interval: details.interval }, (written, total) => {
        })
    console.log("caution, no direct file urls allowed on web, upload will not proceed on web!")
  }
}
// model after s3Upload, accept same args and return same type of promise
// so you can easily switch between calling s3Upload and s3UploadBackground
// calls new react-native module Upload which does a true background upload
// if progressCallback is defined, will call this when we get progress info
// arg is progress 
// optional postId for logging
const s3UploadBackground = (details, progressCallback, postId, userId, username) => {
  console.tron.display({
    name: 's3UploadBackground',
    preview: 'details',
    value: {
      presignedUrl: details.presignedUrl,
      // details: details
    }
  })
  const headers = {
    'Content-Type': 'application/octet-stream',
  }
  // options for background upload routine
  // default will upload from details.url local file url
  // if user had passed in base64 string, will write to tmp file
  // then set the options.path to the tmp file 
  let options = {
    url: details.presignedUrl, // destination remote
    path: details.uri, // file:// uri source local
    method: 'PUT',
    type: 'raw',
    maxRetries: 2, // set retry count (Android only). Default 2
    headers: headers,
    // Below are options only supported on Android
    notification: {
      enabled: true
    },
    useUtf8Charset: true
  }

  // set up generic from-file background uploader
  // has to be from file because if app exits, upload can proceed from file but not from memory
  const bgup = () => {
    console.log("s3uploadBackground:  uploading from file url")
    // note:  Android version of react-native-backgroundupload module needs to
    // be modded to also return response header
    // make a promise that the caller of this expects, and resolve or reject it
    // in the background upload listeners
    // https://stackoverflow.com/questions/26150232/resolve-javascript-promise-outside-function-scope
    let outsideResolve = null
    let outsideReject = null
    const uploadPromise = new Promise(function(resolve, reject) {
      outsideResolve = resolve
      outsideReject = reject
    })
    // need may to think what error response should be when promise is rejected (look at caller)
    // returning an object with an error key to start
    // type of error returned may be string or object at this point
    // works
    /*
    let emitter = new TinyEmitter()

    console.log("emitter created = " + emitter)
    if (emitter)
      emitter.on('progress', (x) => {
        console.log("caught event " + JSON.stringify(x))
      })
    */

    Upload.startUpload(options).then((uploadId) => {
      console.log('background Upload Started')
      logapi.log("background Upload Started for " + JSON.stringify(options))
      Upload.addListener('progress', uploadId, (data) => {
        //console.log(`background Upload Progress for uploadId: ${uploadId} ${data.progress}% postId = ${postId}`)
        logapi.log(`background Upload Progress for uploadId: ${uploadId} ${data.progress.toFixed(3)}% postId = ${postId} userId = ${userId} username = ${username}`)
        /*
        if (emitter)
          emitter.emit('progress', { percent : data.progress }) 
        */
        if (progressCallback) progressCallback(data.progress)
      })
      Upload.addListener('error', uploadId, (data) => {
        //console.log(`background Upload Error for uploadId: ${uploadId} ${data.error}% postId = ${postId}`)
        logapi.log("background Upload Error for " + JSON.stringify(data.error) + " postId = " + postId + " userId = " + userId + " username " + username)
        outsideReject({error: data.error})
      })
      Upload.addListener('cancelled', uploadId, (data) => {
        //console.log(`background Upload Cancelled for uploadId ${uploadId}!`)
        logapi.log("background Upload Cancelled for " + uploadId + " postId = " + postId + " userId = " + userId + " username " + username)
        outsideReject({error: 'cancelled'})
      })
      Upload.addListener('completed', uploadId, (data) => {
        // data includes responseCode: number and responseBody: Object
        //console.log("data = " + JSON.stringify(data, null, 2))
        //console.log("data type = " + typeof data)
        //console.log(`background Upload Completed for uploadId ${uploadId}!`)
        logapi.log("background Upload Completed for uploadId = " + uploadId + " postId = " + postId + " userId = " + userId + " username " + username)

        // make response like the foreground api was responding
        let response = {
          respInfo : {
            status  : data.NSHTTPURLResponse.statusCode,
            headers : data.NSHTTPURLResponse.allHeaderFields
          }
        }
        outsideResolve(response)
    }).catch((err) => {
      console.log('Upload error!', err)
      logapi.log("background Upload CATCH err " + JSON.stringfy(err) + " postId = " + postId + " userId = " + userId + " username " + username)
      outsideReject({error: err})
    }) // catch
    }) // Upload
    return uploadPromise // caller expects a promise which will later resolve (see addListener funcs above for resolve/reject)
  }

  // in memory do the old way to start
  if (details.base64) {
       
    let tmpfile = RNFS.CachesDirectoryPath + "/bgupload" + Date.now() 

    // this should return the background upload promise from bgup() not the write file promise
    // let's see
    return RNFS.writeFile(tmpfile, details.base64, 'base64')
    .then((success) => {
      console.log('s3UploadBackground base64 tmp file written, ready to upload')
      options.path = 'file://' + tmpfile
      return bgup() // returns promise but to whom?
    })
    .catch((err) => {
      console.log("s3UploadBackground base64 file write error " + err.message)
      return null // dont know if caller handles this null yet
    });
    
    /* orig upload from mem example 

    console.log("s3uploadBackground:  uploading from in memory data in foreground")

    // orig way
    return RNFetchBlob.fetch('PUT', details.presignedUrl, headers, details.base64)
      .uploadProgress({ interval: details.interval }, (written, total) => {
      })

    */

  }
  else return bgup() // upload from file, return promise to caller which resolves 
                     // when bg upload finishes or fails

}


export function* deletePost(api,action){
  try {

    const {data : {postId} } = action
  const response =   yield call(api.deletePost, postId)
  if (response.ok) {
    console.tron.display({
    name: `delete post ok`,
     preview :``,
    value: {
    state: response
    }
    })

    yield put(PostsActions.deletePostSuccess(response))
  } else {
    console.tron.display({
      name: `delete post failt`,
       preview :``,
      value: {
      state: response
      }
      })
    yield put(PostsActions.deletePostFailure(response))
  }
  }catch (e){
    console.tron.display({
      name: `deletePost error`,
       preview :``,
      value: {
      state:e
      }
      })

  }
}
// for calling from regular functions
const postFailHelper = function * postFailHelper(api, action, postId, msg) {
  try {
    console.log("post fail helper loc 1")
    yield call(api.deletePost, postId)
    console.log("post fail helper loc 2")
    yield put(PostsActions.createStandardPostFailure("Unable to create post, one of the files (" + msg + ") failed to upload"))
    console.log("post fail helper loc 3")
  } catch (e) { showError(e) }
}

export const createStandardPost = function* createStandardPost(api, action) {
  console.info("createStandardPost start")
  // this spews huge data if any base64 strings to upload
  //console.log("PostsSagas createStandardPost start action = " + JSON.stringify(action))
  try {

    console.info("createStandardPost loc 1")

    yield put(PostsActions.createStandardPostProgress(0.5)) // start at 0.5 in case video render reserve first 0.5 for video render
    const { post, files, emitter } = action

    console.info("createStandardPost loc 2")

    if (files.length < 2) {
      yield put(PostsActions.createStandardPostFailure("Unable to create post, too few files: " + files.length))
      return;
    }
    if (typeof post.AspectRatio == 'undefined' || isNaN(parseFloat(post.AspectRatio)) || post.AspectRatio <= 0) {
      yield put(PostsActions.createStandardPostFailure("Unable to create post, Post aspect ratio invalid"))
      return
    }
    if (typeof post.MediaType == 'undefined' || MEDIA_TYPES.indexOf(post.MediaType) == -1) {
      yield put(PostsActions.createStandardPostFailure("Unable to create post, MediaType is invalid"))
      return
    }
    /*
    const resetAction = NavigationActions.replaceWithAnimation({
      routeName: `home`, params: { isScroll  :true, isNewPost : true} })
    */
     console.info("createStandardPost loc 3")
     const resetAction = NavigationActions.reset({
       index: 0,
       key: null,
       actions: [
         NavigationActions.navigate({ routeName: 'home', params: { index: 1 } }),
      ],
    })
    yield put(resetAction)

/*
    const ziggystardustOfferId = Math.random() < 0.5 ?
      'AS5758b527028b600001ac1f18a32d6c-1565142067.123388' : // Cactus Club
      'AS5758b527028b600001ac1f18a32d6c-1565386740.131237' // Red Robin
    const postExtra = Object.assign({}, post, {OfferIdsOnCompletion: ziggystardustOfferId})
*/

    console.info("createStandardPost loc 4")
    const newPostResponse = yield call(api.createStandardPost, post)
    if (!newPostResponse.ok) {
      let httpCode = ''
      let logRef = 'unknown'
      let errMessage = ''
      try {
        httpCode = newPostResponse.data.httpCode
        logRef = newPostResponse.data.logRef
        errMessage = newPostResponse.data.errors[0].detail
      }
      catch (e) {
      }
      yield put(PostsActions.createStandardPostFailure(`Unable to create post, record creation failed. httpCode ${httpCode}, logRef: ${logRef}, message: ${errMessage}`))
      Alert.alert(
        'Create Post failed',
        errMessage,
        [
          {text: I18n.t("editpost.gotIt"), onPress: () => console.log('got it pressed')},
        ],
        { cancelable: false }
      )
      return;
    }
    yield put(PostsActions.createStandardPostProgress(0.6)) // assume starting at 0.5

    console.info("CreatePostSagas createPost response ok")
    const apiResponse = newPostResponse.data
    const detail = apiResponse.data[0]
    const postId = detail.PostId

    console.info("new post id = " + postId)

    const fullState = yield select() // the entire app state
    const authState = fullState.auth
    const userId = authState.user.UserId
    const username = authState.user.Username
    
    //const userId = detail.UserId
    //const username = detail.Username

    let detailedFiles = files.concat() // clone
    const fileCount = detailedFiles.length
    let totalFileSize = 0
    console.log("createStandardPost before file loop")
    for (let i = 0; i < fileCount; i++) {
      // web we have inline data uri
      //const statResult = yield RNFS.stat(detailedFiles[i].uri);
      console.info("i = " + i + " detailedFiles[i].uri.length = " + detailedFiles[i].uri.length)
      const statResult = {size: detailedFiles[i].uri.length}
      // dont dump out uri, data uri is huge
      //console.log(`createStandardPost size: ${statResult.size}, uri: ${detailedFiles[i].uri}`);
      switch (detailedFiles[i].kind) {
        case 'thumbImage': detailedFiles[i].presignedUrl = detail.thumbImage._url; break;
        case 'thumbVideo': detailedFiles[i].presignedUrl = detail.thumbVideo._url; break;
        case 'tileVideo': detailedFiles[i].presignedUrl = detail.tileVideo._url; break;
        case 'image': detailedFiles[i].presignedUrl = detail.image._url; break;
        case 'video': detailedFiles[i].presignedUrl = detail.video._url; break;
        default:
          console.log("deleting post due to default situation")
          yield call(api.deletePost, postId)
          yield put(PostsActions.createStandardPostFailure("Unknown file kind: " + detailedFiles[i].kind))
          return
      }
      totalFileSize += statResult.size
      detailedFiles[i].size = statResult.size;
      detailedFiles[i].interval = 500; // future progress update rate in ms
    }
    console.info("createStandardPost totalFileSize: " + totalFileSize)
    for (let i = 0; i < fileCount; i++) {
      detailedFiles[i].progressWeight = detailedFiles[i].size / totalFileSize;
    }
    //console.log("createStandardPost detailedFiles: " + JSON.stringify(detailedFiles))
    console.info("Calling upload for post files")
    let eTagList = []
    let uploadWrappingPromises = []
    let uploadOk = true // assume good unless one of the uploads fails
    let nFinished = 0
    let fileProgDecPct = 0
    let lastProgress = 0
    const progressMinDelta = 0.0033
    
    for (let index = 0; index < fileCount; index++) {
      console.info("try to upload file " + index)
      try {
       // return a promise that is resolved when upload is completed or fails
       function uploadOne(file) {
          // we need to process the result of this when it resolves here
          let outsideResolve = null
          let outsideReject = null
          const wrappingPromise = new Promise(function(resolve, reject) {
            outsideResolve = resolve
            outsideReject = reject
          })
          // upload progress is 0 to 100 float
          const fileProgressWeight = detailedFiles[index].progressWeight
          // try regular foreground upload for web
          let uploadPromise = s3Upload/*Background*/(detailedFiles[index], 
                                                 (p) => {
                                                    console.log("createStandardPost upload progress callback " + p)
                                                    // full file count progress for ref(0.5 / fileCount) * (nFinished)
                                                    let partialFinished = nFinished + (p/100.0)
                                                    // see logic below, this is the same except allowing for a partially uploaded file
                                                    // this might not be having any effect because called from callback or?
                                                    //console.log("loc 1 before std prog")
                                                    // there is a bug here, this has no effect on progress bar length no matter what number i put
                                                    // calling this from a callback may be not supported or ???
                                                    // let progress = 0.6 + (0.3 / fileCount) * partialFinished

                                                    const fileFracProgress = fileProgDecPct + fileProgressWeight * (p / 100.0)
                                                    let progress = 0.6 + 0.3 * Math.min(1, fileFracProgress)
                                                    console.log(`createStandardPost fileProgDecPct ${fileProgDecPct}, fileProgressWeight ${fileProgressWeight}, fileFracProgress ${fileFracProgress}, p ${p}, progress ${progress}`)
                                                    // console.log("new overall create post progress: " + progress)
                                                    if (progress - lastProgress >= progressMinDelta) {
                                                      console.log(`createStandardPost progress ${progress} (callback)`)
                                                      if (emitter)
                                                        emitter.emit('progress', { percent : progress }) 
                                                      else
                                                        console.log("no emitter in upload promise")
                                                      // PostsActions.createStandardPostProgress(progress)
                                                      lastProgress = progress
                                                    }
                                                    //console.log("loc 2 after std prog")
                                                 },
                                                 postId, userId, username
          )
          uploadPromise.then((uploadResponse) => {
            if (uploadResponse.respInfo.status != 200) {
              // try again after a small delay?
              console.info("s3 upload failed, response = " + JSON.stringify(uploadResponse, null, 2))
              // cannot do yield call or yield put directly since the containing function is not a generator (function *)
              // so set a flag and do this later
              //yield call(api.deletePost, postId)
              //yield put(PostsActions.createStandardPostFailure("Unable to create post, at least one of the files failed to upload"))
              uploadOk = false
            }
            // cant call the function that sets progress bar here, need to call from generator function
            // so just count here
            nFinished++ 
            fileProgDecPct += fileProgressWeight
            console.info('ready to call progress C')
            // first 0.2 is reserved for video rendering
            // this one might not be working either (create standard post progress)
            // PostsActions.createStandardPostProgress(0.6 + (0.3 / fileCount) * (nFinished)) // TODO ???
            let progress = 0.6 + 0.3 * Math.min(1, fileProgDecPct)
            if (progress - lastProgress >= progressMinDelta) {
              console.log(`createStandardPost progress ${progress} (done)`)
              if (emitter)
                emitter.emit('progress', { percent : progress }) 
              // PostsActions.createStandardPostProgress(progress)
              lastProgress = progress
            }
            console.info('ready to call progress D')
            // debug only setBadgeCount(index+1)
            eTagList.push(uploadResponse.respInfo.headers.Etag) // empty headers on web hmm
            console.info("ready to resolve wrapping promise")
            outsideResolve()
          })
          
          return wrappingPromise
        }
        // start upload of 1 file but don't wait here, loop around and start another
        // this should get all uploads proceeding quickly in case user puts app into background
        // uploadWrappingPromises.push(uploadOne(detailedFiles[index])) 
        yield call(uploadOne, detailedFiles[index])
      }
      // note:  I have seen upload fail but neither above status != 200 nor catch gets triggered
      // silent fail
      catch(error) { // this is triggered if we background the app while a large s3 upload is going on
                     // however, error is merely line number info in the main.jsbundle file, nothing usable
        console.info("s3 upload catch error = " + JSON.stringify(error, null, 2))
        // does Alert work in * generator type functions?
        Alert.alert(
          'S3 upload failed',
          'Uploading file failed ' + index + ' of ' + fileCount,
          [
            {text: I18n.t("editpost.gotIt"), onPress: () => console.log('got it pressed')},
          ],
          { cancelable: false }
        )
      }
      // orig progress meter does by file count but all uploads above go onto bg upload 
      // we could possibly do better because code within s3UploadBackground reports % uploaded
      // but does not yet report it out to this function (e.g. maybe pass in a function to s3UploadBackground
      // to call this progress meter update?)
      // move this to upload complete but it is tricky
      // yield put(PostsActions.createStandardPostProgress(0.2 + (0.5 / fileCount) * (index + 1)))
      console.info("Finished launching upload " + detailedFiles[index].kind)
    } // index

    // console.log("yield for all files to finish uploading")
    // wait for all upload promises to resolve
    // if we don't do this, the code that checks for post files fails and then the whole post fails
    // yield call(Promise.all, uploadWrappingPromises)
    console.info("COMPLETE yield for all files to finish uploading")
    console.tron.log("All files uploaded")

    // error handling if any of the background uploads failed
    if (!uploadOk) {
      console.info('at least one of the uploads failed, get rid of post')
      yield call(api.deletePost, postId)
      yield put(PostsActions.createStandardPostFailure("Unable to create post, at least one of the files failed to upload"))
      return // and don't proceed
    }

    // leave some time for files to show up on the api's s3 server
    yield delay(1000)
    // console.tron.log("after 1000ms delay")
    // when all files are uploaded it is 0.90
    yield put(PostsActions.createStandardPostProgress(0.92))

    let tries = 0
    let allFilesPresent = false
    do {
      const fileListResponse = yield call(api.listPostFiles, postId)
      console.log("fileListResponse = " + JSON.stringify(fileListResponse))
      console.tron.display({
        name: 'CreatePostSagas',
        preview: 'createPost fileListResponse',
        value: {
          fileListResponse: fileListResponse
        }
      })
      if (!fileListResponse.ok) {
        console.tron.log("CreatePostSagas createPost listPostFiles failed")
        console.info("--- POST FAILED LOC 1")
        Alert.alert(
          'Create post failed',
          'List post files on server failed',
          [
            {text: I18n.t("editpost.gotIt"), onPress: () => console.log('got it pressed')},
          ],
          { cancelable: false }
        )
        yield call(api.deletePost, postId)
        yield put(PostsActions.createStandardPostFailure("Unable to create post, could not list files on server"))
        return
      }
      const serverFiles = fileListResponse.data.data
      console.info("serverFiles length = " + serverFiles.length)

      console.info("eTagList length = " + eTagList.length)

      console.info("eTagList = " + JSON.stringify(eTagList))

      allFilesPresent = eTagList.length == serverFiles.length // count is all we will check for web until we can fix missing ETag response bug

      if (false && !allFilesPresent) { // patch web dont check each one since we didnt get a response header yet w/ ETag in it
        for (let i = 0; i < serverFiles.length; i++)
          console.log(i + " ETag " + serverFiles[i].ETag)
          if (eTagList.indexOf(serverFiles[i].ETag) == -1)
            allFilesPresent = false;
      }
      if (!allFilesPresent) {
        console.info("files not seen by api yet, delay 2s")
        console.tron.log("files not seen by api yet, delay 2s")
        yield delay(2000)
      }
      tries++
      yield put(PostsActions.createStandardPostProgress(0.92 + (tries/200)))
      console.tron.log("fileListResponse tries: " + tries + ", present: " + allFilesPresent)
    } while (!allFilesPresent && tries < 10)
    yield put(PostsActions.createStandardPostProgress(0.97))

    if (!allFilesPresent) {
      console.tron.log("CreatePostSagas createPost files never showed up")
      
      alert('Create post failed ... Media files never showed up on server')

      // cap react-native Alert is broken on react-native-web currently, havent looked into it yet
      Alert.alert(
        'Create post failed',
        'Media files never showed up on server',
        [
          {text: I18n.t("editpost.gotIt"), onPress: () => console.log('got it pressed')},
        ],
        { cancelable: false }
      )
      console.info("--- POST FAILED LOC 2") // this is happening but no alert on web
      yield call(api.deletePost, postId)
      yield put(PostsActions.createStandardPostFailure("Unable to create post, files did not show up at server"))
      return
    }

    console.info("ready to call FINISH POST")
    const finishPostResponse = yield call(api.finishPost, postId)
    console.info("finish post response status = " + finishPostResponse.status)
    if (finishPostResponse.ok) {
      console.tron.log("CreatePostSagas createPost post was completed")
      // const apiResponse = finishPostResponse.data
      // const post = apiResponse.data
      yield put(PostsActions.createStandardPostSuccess(finishPostResponse))
      console.info("+++ POST COMPLETE")
      AsyncStorage.setItem("EditPostScreenSavedCaption", '') // only clear caption if post is successful see EditPostScreen
      // debug only setBadgeCount(999) // tell test user that post is complete

      /*
      Alert.alert(
        'Post complete!',
        'What more do you want?',
        [
          {text: I18n.t("editpost.gotIt"), onPress: () => console.log('got it pressed')},
        ],
        { cancelable: false }
      )
      */
    }
    else {
      console.info("--- POST FAILED LOC 3 status = " + finishPostResponse.status)
      Alert.alert(
        'Create post failed',
        'Finish post failed, status = ' + finishPostResponse.status,
        [
          {text: I18n.t("editpost.gotIt"), onPress: () => console.log('got it pressed')},
        ],
        { cancelable: false }
      )
      console.tron.log("CreatePostSagas createPost finishPost failed")
      yield call(api.deletePost, postId)
      yield put(PostsActions.createStandardPostFailure("Unable to create post, could not finalize record"))
    }

  }
  catch (e) {
    Alert.alert(
      'Create post failed',
      'Error caught:\n' + JSON.stringify(e, null, 2),
      [
        {text: I18n.t("editpost.gotIt"), onPress: () => console.log('got it pressed')},
      ],
      { cancelable: false }
    )
    console.info("--- POST FAILED LOC 4 CATCH e = " + JSON.stringify(e, null, 2)) 
    console.tron.display({
      name: 'CreatePostSagas',
      preview: "error",
      value: {
        message: e.message,
        e: e
      }
    })
    yield put(PostsActions.createStandardPostFailure("Unable to create post"))
  }
}
